module.exports = __webpack_public_path__ + "static/media/agricultural-banner.fb93c8c4.jpg";